










import { Component, Vue,Prop,Watch } from 'vue-property-decorator'
import { outputTrends } from '@/api/home'
const echarts = require('echarts')
import NoData from '@/components/NoData'
@Component({
  name: 'IndustrialOutput',
  components:{NoData}
})
export default class IndustrialOutput extends Vue {
    @Prop({default:''}) code!:string
  private data : any = []
  outputTrendsData(e:any){
    outputTrends({
      regionCode:e,
      unitType:0
    }).then((res :any)=>{
      if(res.status == 0){
        this.data = []
        res.data.forEach((item:any) =>{
            this.data.push([item.statDate,Number(item.dataValue) ])
        })
        this.init()
      }
    //   if(!res.data){
    //     this.data = null
    //   }
    }).catch(err =>{
    })  
  }
  private init() {
      const main = document.getElementById('IndustrialOutput')
      // 基于准备好的dom，初始化echarts实例
      const myChart:any = echarts.init(main as HTMLDivElement)
      // 指定图表的配置项和数据
      const option = {
        tooltip: {},
        grid: {
          top:'8%',
          left: '0',
          // right: '2%',
          bottom: '3%',
          containLabel: true
        },
        // legend: {
        //   data: ['销量'],
        // },
        // barCategoryGap:'65%',
        yAxis:{
        //   inverse: true,//倒叙
            splitLine:{
                show:false
            },
          axisLabel:{
                // interval:0,
                textStyle: {
                    align:'right',
                    baseline:'middle'
                }
            }
        },
        xAxis: {
            type:'category',
            axisLine: {show: false},
              axisTick: {
        show: false
    },
            splitLine:{
                show:false
            },
        },
        series: [
          {
            name: '',
            type: 'line',
            smooth: true,
            areaStyle: {
                // Color:'rgb(181 241 199)'
            },
            itemStyle : {
              normal : {
                color:'#144689;',
                lineStyle:{
                    color:'#2576f0'
                },
			        },
            },
            data: this.data,
          }
        ],
      }
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option)
  }
  updatafun(){
    setTimeout(() => {
      this.init()
    }, 0)
  }
 @Watch('code')
    onChangeData(e:any) {
        this.outputTrendsData(e)
    }
  created() {
    this.outputTrendsData(this.code)
  }
}


